import React from 'react';
import { Box, Grid, Icon, Typography } from '@mui/material';
import { Tooltip } from '@biq/apex-ui';
import HelpIcon from '@mui/icons-material/Help';
import { dataDisabledCardStyles } from './data-card-helper';
import { DataCardDisabledIcon } from '../../../../assets';
import { CardLoader } from 'components';

export const DataDisabledCard = ({
    isLoading,
    label,
}: {
    isLoading: boolean;
    label: string;
}): React.JSX.Element => {
    return (
        <Grid sx={dataDisabledCardStyles.container}>
            {isLoading ? (
                <Typography component={'span'} variant='h4'>
                    <CardLoader />
                </Typography>
            ) : (
                <>
                    <Grid>
                        <Typography
                            sx={dataDisabledCardStyles.headingTextStyles}
                        >
                            {label}
                        </Typography>
                    </Grid>
                    <Grid>
                        <img
                            src={DataCardDisabledIcon}
                            alt='data-card-disabled-icon'
                        />
                    </Grid>
                    <Grid>
                        <Typography
                            sx={dataDisabledCardStyles.subheadingTextStyles}
                        >
                            Upgrade your plan to access this{' '}
                            <Box
                                component={'span'}
                                sx={
                                    dataDisabledCardStyles.helpIconWithTextStyles
                                }
                            >
                                feature
                                <Tooltip
                                    title='Contact sales@burstiq.com to upgrade today.'
                                    arrow
                                    placement={'top'}
                                    slotProps={{
                                        popper: {
                                            sx: dataDisabledCardStyles.popperStyles,
                                            modifiers: [
                                                {
                                                    name: 'offset',
                                                    options: {
                                                        offset: [0, 4],
                                                    },
                                                },
                                            ],
                                        },
                                    }}
                                >
                                    <Icon
                                        fontSize='inherit'
                                        color='primary'
                                        sx={
                                            dataDisabledCardStyles.helpIconTooltipStyles
                                        }
                                    >
                                        <HelpIcon />
                                    </Icon>
                                </Tooltip>
                            </Box>
                        </Typography>
                    </Grid>
                </>
            )}
        </Grid>
    );
};
